const nav_en = {
  dashboard: 'Dashboard',
  users: 'Users',
  items: 'Items',
  myPlans: 'My Plans',
  categories: 'Categories',
  tags: 'Tags',
  manual: 'Manual',
  adminHubBanner: 'Logged in as {name} via Admin Hub',
  adminHubBannerNoName: 'Logged in via Admin Hub',
  adminHubLogout: 'Log out',
  logout: 'Log out',
  customerSwitch: {
    trigger: 'Active customer: {name}. Switch customer',
    title: 'Switch customer',
    customerNo: 'Cust. no. {number}',
    current: 'Currently active',
    sessionNote: 'Applies to this session on this device only.',
    switched: 'You are now working in {name}',
    confirmTitle: 'Discard unsaved changes?',
    confirmBody:
      'You have unsaved changes on this page. Switching to {name} reloads the app and discards them.',
    confirm: 'Switch anyway',
    cancel: 'Cancel',
  },
  tenantSwitch: {
    title: 'work4all tenant',
    tenantNo: 'Tenant {code}',
    readOnly: 'read-only',
    trigger: 'Tenant: {name} – switch',
    loginNote: 'Switching signs you in again on the other tenant.',
    locked: 'locked, not reported read-only',
    liveConfirmTitle: 'Switch to the real data?',
    liveConfirmBody:
      '{name} holds LA CONCEPT’s real data. Its backend is connected read-only: changes to work4all are refused there. Switching signs you out.',
    liveConfirm: 'Switch',
    confirmTitle: 'Discard unsaved changes?',
    confirmBody:
      'This page has unsaved changes. Switching to {name} signs you out and the changes are lost.',
    confirm: 'Switch anyway',
    cancel: 'Cancel',
  },
}

export default nav_en
